import { getStockData, getValuation } from '../lib/stockServices'
import { EventTypes } from 'redux-segment';

const initState = {
  currentSymbol: '',
  stockData: {},
  valuation: {},
  isLoading: true,
  reutersError: false
}

// EVENTS
const CURRENT_SYMBOL_UPDATE = 'CURRENT_SYMBOL_UPDATE'
const STOCK_DATA_SUCCESS = 'STOCK_DATA_SUCCESS'
const POLARIS_VALUATION_SAVE = 'POLARIS_VALUATION_SAVE'
const POLARIS_VALUATION_UPDATE = 'POLARIS_VALUATION_UPDATE'
const STOCK_DATA_LOADING = 'STOCK_DATA_LOADING'
const REUTERS_ERROR = 'REUTERS_ERROR'

// ACTIONS
export const updateCurrent = (val) => ({
  type: CURRENT_SYMBOL_UPDATE,
  payload: val,
  meta: {
    analytics: {
      eventType: EventTypes.page,
      eventPayload: {
        event: CURRENT_SYMBOL_UPDATE,
        properties: {
          path: `/quote/${val}`,
          url: window.location.hostname + `/quote/${val}`
        },
      },
    },
  },
})
const saveStock = (data) => ({type: STOCK_DATA_SUCCESS, payload: data})
const saveValuation = (data) => ({type: POLARIS_VALUATION_SAVE, payload: data})
const updateValuation = (data) => ({type: POLARIS_VALUATION_UPDATE, payload: data})
const isLoading = (bool) => ({type: STOCK_DATA_LOADING, payload: bool})
const reutersFetchError = (bool) => ({type: REUTERS_ERROR, payload: bool})

// ASYNC ACTIONS
export const fetchStock = (symbol) => {
  return (dispatch) => {
    dispatch(isLoading(true))
    dispatch(updateCurrent(symbol))
    getStockData(symbol)
      .then(data => dispatch(saveStock(data)))
      .then((data) => {
        const {fmpData, ivvData, reutersData} = data.payload

        if (reutersData !== undefined) {
          // Get initial valuation
          const valuation = getValuation(symbol, fmpData, ivvData, reutersData, null, null)
          dispatch(reutersFetchError(false))
          dispatch(saveValuation(valuation))
        } else {
          dispatch(reutersFetchError(true))
        }

        dispatch(isLoading(false))
      })
  }
}

export const fetchValuation = (growth, PM, PE) => {
  return (dispatch, getState) => {
    const { stockData, currentSymbol } = getState().stock
    const { fmpData, reutersData, ivvData } = stockData

    // Get updated valuation
    const valuation = getValuation(currentSymbol, fmpData , ivvData, reutersData, growth, PM, PE)
    dispatch(updateValuation(valuation))
  }
}

// REDUCER
export default (state = initState, action) => {
  switch (action.type) {
    case CURRENT_SYMBOL_UPDATE:
      return {...state, currentSymbol: action.payload}
    case STOCK_DATA_SUCCESS:
      return {...state, stockData: action.payload}
    case POLARIS_VALUATION_SAVE:
    case POLARIS_VALUATION_UPDATE:
      return {...state, valuation: action.payload}
    case STOCK_DATA_LOADING:
      return {...state, isLoading: action.payload}
    case REUTERS_ERROR:
      return {...state, reutersError: action.payload}
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/stock.js